"use strict";


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd/dist/cjs/decorators/interfaces.js
// module id = 1435
// module chunks = 0